import { NgModule } from '@angular/core';
import { TrackingDeliveryComponentModule } from './tracking-delivery/tracking-delivery.module';
import { TrackingPickupComponentModule } from './tracking-pickup/tracking-pickup.module';

@NgModule({
  imports: [TrackingDeliveryComponentModule, TrackingPickupComponentModule],
})
export class TrackingUiModule {}
